import {createReducer, on} from '@ngrx/store';
import * as SummaryActions from './summary.actions';
import {SummaryDocumentDTO, SummaryDTO} from '../../dto/summary';

export interface SummaryState {
  projectSummary: { [projectId: number]: SummaryDTO[] };
  selectedSummary: SummaryDTO | null;
  paperSummary: { [paperId: number]: SummaryDocumentDTO };
  papersSummaryBySummary: { [summaryId: number]: SummaryDocumentDTO[] };
  loading: boolean;
  generating: boolean;
  error: string | null;
  loadingForPaper: boolean;
  errorForPaper: string | null;
  projectNotFound: boolean;
  summaryProcessRunning: boolean;
}

export const initialState: SummaryState = {
  projectSummary: {},
  selectedSummary: null,
  paperSummary: {},
  papersSummaryBySummary: {},
  loading: false,
  generating: false,
  error: null,
  loadingForPaper: false,
  errorForPaper: null,
  projectNotFound: false,
  summaryProcessRunning: false,
};

export const summaryReducer = createReducer(
  initialState,
  on(SummaryActions.loadProjectSummary, (state) => ({
    ...state,
    loading: true,
    error: null,
    projectNotFound: false,
    selectedSummary: null,
  })),
  on(SummaryActions.loadProjectSummarySuccess, (state, {summary, projectId}) => ({
    ...state,
    loading: false,
    selectedSummary: summary
  })),
  on(SummaryActions.loadProjectSummaryFailure, (state, {error, notFound}) => ({
    ...state,
    loading: false,
    error: error,
    projectNotFound: notFound === true, // set flag if notFound is true
  })),
  on(SummaryActions.loadProjectSummaries, (state) => ({
    ...state,
    loading: true,
    error: null,
    projectNotFound: false,
  })),
  on(SummaryActions.loadProjectSummariesSuccess, (state, {summaries, projectId}) => ({
    ...state,
    loading: false,
    projectSummary: {
      ...state.projectSummary,
      [projectId]: summaries,
    },
  })),
  on(SummaryActions.loadProjectSummariesFailure, (state, {error, notFound}) => ({
    ...state,
    loading: false,
    error: error,
    projectNotFound: notFound === true, // set flag if notFound is true
  })),
  on(SummaryActions.deleteSummary, (state, {}) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SummaryActions.deleteSummarySuccess, (state, {projectId, summaryId}) => ({
    ...state,
    loading: false,
    projectSummary: {
      ...state.projectSummary,
      [projectId]: [
        ...state.projectSummary[projectId].filter(f => f.id !== summaryId),
      ],
    },
  })),
  on(SummaryActions.deleteSummaryFailure, (state, {error, projectId}) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(SummaryActions.generateProjectSummary, (state, {projectId}) => ({
    ...state,
    generating: true,
    error: null,
    summaryProcessRunning: true
  })),
  on(SummaryActions.generateProjectSummarySuccess, (state, {summary, projectId}) => ({
    ...state,
    generating: false,
    projectNotFound: false,
    projectSummary: {
      ...state.projectSummary,
      [projectId]: [...state.projectSummary[projectId]?.filter(s => s.id !== summary.id) ?? [], summary],
    },
    selectedSummary: (state.selectedSummary !== null && state.selectedSummary.id === summary.id) ? summary : state.selectedSummary
  })),
  on(SummaryActions.generateProjectSummaryFailure, (state, {error, projectId}) => ({
    ...state,
    generating: false,
    projectNotFound: true,
    summaryProcessRunning: false,
    error: error,
  })),
  on(SummaryActions.generatePaperSummary, (state,) => ({
    ...state,
    loadingForPaper: true,
    errorForPaper: null,
  })),
  on(SummaryActions.generatePaperSummarySuccess, (state, {summary, paperId}) => ({
    ...state,
    loadingForPaper: false,
    paperSummary: {
      ...state.paperSummary,
      [paperId]: summary,
    },
  })),
  on(SummaryActions.generatePaperSummaryFailure, (state, {error, paperId}) => ({
    ...state,
    loadingForPaper: false,
    errorForPaper: error,
  })),
  on(
    SummaryActions.generateProjectSummaryNotRunning,
    SummaryActions.generateProjectSummaryComplete,
    SummaryActions.stopGenerateProjectSummarySuccess, (state) => ({
      ...state,
      summaryProcessRunning: false,
    }))
);
